export default __webpack_public_path__ + "static/media/1A.5c4e2857.png";